/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown>, since: "false" | "true" }} Motor_IncidentInputs */



/**
* | since | output |
* | --- | --- |
* | "false" | "Technical incident (engine)" |
* | "true" | "Technical incident (engine) since {date}" |
*
* @param {Motor_IncidentInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const motor_incident = /** @type {((inputs: Motor_IncidentInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Motor_IncidentInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		if (i?.since === "false") return /** @type {LocalizedString} */ (`Technical incident (engine)`);
		if (i?.since === "true") return /** @type {LocalizedString} */ (`Technical incident (engine) since ${i?.date}`);
		return /** @type {LocalizedString} */ ("motor_incident");
	}
	{
		if (i?.since === "false") return /** @type {LocalizedString} */ (`Incident technique (moteur)`);
		if (i?.since === "true") return /** @type {LocalizedString} */ (`Incident technique (moteur) depuis le ${i?.date}`);
		return /** @type {LocalizedString} */ ("motor_incident");
	}
});